import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiPhone, BiEnvelope, BiLogoLinkedin, BiChevronRight, BiSolidEnvelope, BiMobile, BiLogoVisualStudio, BiLogoChrome, BiLogoWordpress, BiBuildings, BiAnalyse, BiDoorOpen, BiLogoMicrosoft, BiData, BiBookReader, BiSolidData } from "react-icons/bi";
import { useTranslations } from "../../locales/useTranslations";

const DienstleistungenAuflistung = () => {
  const { t } = useTranslations();
  return (
    <>
      <section className="features-area pt-100 pb-70">

        <div className="container">
          <span className="sub-title">{t('dienstleistungen_auflistung_sub_title')}</span>
          <h2>{t('dienstleistungen_auflistung_title')}</h2>
          <hr className="dienstleistung-divider" />
        </div>

        <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <Link href="/app-development" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiMobile />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_app_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_app_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_app_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiMobile />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6">
                <Link href="/software-development" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiLogoVisualStudio />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_software_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_software_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_software_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiLogoVisualStudio />
                    </div>
                  </div>
                </Link>
              </div>

            </div>
          </div>
        </FadeInAnimation>

        <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">

              <div className="col-sm-6">
                <Link href="/web-development" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiLogoChrome />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_web_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_web_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_web_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiLogoChrome />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6">
                <Link href="/web-development/wordpress-entwicklung/" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiLogoWordpress />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_wordpress_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_wordpress_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_wordpress_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiLogoWordpress />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6">
                <Link href="/web-development/wordpress-betreuung/" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiLogoWordpress />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_wordpress_betreuung_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_wordpress_betreuung_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_wordpress_betreuung_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiLogoWordpress />
                    </div>
                  </div>
                </Link>
              </div>

            </div>
          </div>
        </FadeInAnimation >


        <div className="container pb-35">
          <div className="service-details-content">
            <div className="service-details">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('dienstleistungen_auflistung_large_info_box_title')}</h4>
                  <span>{t('dienstleistungen_auflistung_large_info_box_description')}</span>
                </div>

                <div className="single-info-box">
                  <h4>{t('dienstleistungen_auflistung_single_info_box_title')}</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="#" className="default-btn">
                    {t('dienstleistungen_auflistung_single_info_box_button')}
                  </Link>
                </div>
              </div>
            </div>


          </div>

        </div>
      </section >


      <section className="features-area bg-f4f6fc ptb-70">

        <div className="container">
          <span className="sub-title">{t('dienstleistungen_auflistung_consulting_sub_title')}</span>
          <h2>{t('dienstleistungen_auflistung_consulting_title')}</h2>
          <hr className="dienstleistung-divider" />
        </div>

        <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <Link href="/it-consulting" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiBuildings />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_consulting_it_beratung_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_consulting_it_beratung_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_consulting_it_beratung_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiBuildings />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6">
                <Link href="/business-analytics" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiAnalyse />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_consulting_business_analytics_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_consulting_business_analytics_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_consulting_business_analytics_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiAnalyse />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </FadeInAnimation>

        <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <Link href="/business-analytics/power-bi" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiLogoMicrosoft />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_consulting_power_bi_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_consulting_power_bi_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_consulting_power_bi_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiLogoMicrosoft />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6">
                <Link href="/business-analytics/metabase" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiDoorOpen />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_consulting_metabase_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_consulting_metabase_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_consulting_metabase_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiDoorOpen />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </FadeInAnimation>

        <div className="container pb-35">
          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1200"
          >
            <Link href="/kontakt" className="default-btn">
              <BiSolidEnvelope />{t('dienstleistungen_auflistung_consulting_contact_button')}
            </Link>
          </div>
        </div>
      </section >

      <section className="features-area ptb-70">
        <div className="container">
          <span className="sub-title">{t('dienstleistungen_auflistung_ki_ml_sub_title')}</span>
          <h2>{t('dienstleistungen_auflistung_ki_ml_title')}</h2>
          <hr className="dienstleistung-divider" />
        </div>

        <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <Link href="/kuenstliche-intelligenz/" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiSolidData />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_ki_ml_kuenstliche_intelligenz_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_ki_ml_kuenstliche_intelligenz_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_ki_ml_kuenstliche_intelligenz_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiSolidData />
                    </div>
                  </div>
                </Link>
              </div>

              {/* <div className="col-sm-6">
                <Link href="/kuenstliche-intelligenz/firmendaten/" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiData />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_ki_ml_firmendaten_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_ki_ml_firmendaten_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_ki_ml_firmendaten_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiData />
                    </div>
                  </div>
                </Link>
              </div> */}
            </div>
          </div>
        </FadeInAnimation>

        {/* <FadeInAnimation direction="up" delay={100}>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <Link href="/kuenstliche-intelligenz/socialmedia/" className="read-more">
                  <div className="features-box">
                    <div className="icon">
                      <BiBookReader />
                    </div>
                    <h3>{t('dienstleistungen_auflistung_ki_ml_social_media_reports_title')}</h3>
                    <p dangerouslySetInnerHTML={{ __html: t('dienstleistungen_auflistung_ki_ml_social_media_reports_description') }} />
                    <span className="features-box-action">{t('dienstleistungen_auflistung_ki_ml_social_media_reports_readMore')}
                    <BiChevronRight />
                    </span>
                    <div className="back-icon">
                      <BiBookReader />
                    </div>
                  </div>
                </Link>
              </div>


            </div>
          </div>
         </FadeInAnimation> */}

        <div className="container pb-35">

          <div className="service-details-content">

            <div className="service-details">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('dienstleistungen_auflistung_ki_ml_large_info_box_title')}</h4>
                  <span>{t('dienstleistungen_auflistung_ki_ml_large_info_box_description')}</span>
                </div>

                <div className="single-info-box">
                  <h4>Kontakt</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="#" className="default-btn">
                    {t('dienstleistungen_auflistung_ki_ml_single_info_box_button')}
                  </Link>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section>

    </>
  );
}

export default DienstleistungenAuflistung;
